module.exports = __webpack_public_path__ + "media/assets/images/smart_working/7-2-s-830e403258ae450a3a198922c78633c0.jpg";